import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardHeader from '@mui/material/CardHeader';

import { ReportDefinitionWithIcon } from 'types/reports';

interface ReportCardProps {
  report: ReportDefinitionWithIcon;
  onGenerate: (report: ReportDefinitionWithIcon) => void;
}

export function ReportCard({ report, onGenerate }: ReportCardProps) {
  return (
    <Card>
      <CardHeader
        avatar={<Avatar sx={{ bgcolor: 'primary.main' }}>{report.icon}</Avatar>}
        title={report.title}
        subheader={report.description}
        titleTypographyProps={{ variant: 'subtitle1', fontWeight: 'bold' }}
        subheaderTypographyProps={{ variant: 'body2' }}
      />
      <CardActions sx={{ justifyContent: 'flex-end', pt: 0 }}>
        <Button size="small" variant="outlined" onClick={() => onGenerate(report)}>
          Generate
        </Button>
      </CardActions>
    </Card>
  );
}

export default ReportCard;
